<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix" style="min-height: 270px">
      <div id="main_area">
        <div class="information">
          <h3>{{pageData.MenuName}}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>常見問題類別</td>
                  <td colspan="3">
                    <select v-model="form.class_Seq" style="min-width: 480px">
                      <option
                        v-for="(item, index) in dropDownList.classSeq"
                        :value="item.classSeq"
                        :key="index"
                      >
                        {{ item.className }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="f_center">
                    <input
                      type="submit"
                      class="btn"
                      value="查詢"
                      @click="
                        () => {
                          this.form.currentpage = 1;
                          this.form.pagesize = 10;
                          this.doQuery();
                        }
                      "
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="新增"
                      @click="btnAdd()"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- 查詢結果開始-->
    <div class="information">
      <table width="100%">
        <tbody>
          <tr>
            <td></td>
            <td v-if="grid.paginaiton" align="right">
              <input
                type="button"
                value="<<"
                class="btn"
                style="height: 28px"
                @click="form.currentpage = grid.paginaiton.pageNo - 1"
                v-show="grid.paginaiton.pageNo > 1"
              />
              <span
                v-for="(data, index) in grid.paginaiton.pages"
                :key="index"
                style="cursor: pointer"
                :style="
                  grid.paginaiton.pageNo == data ? 'color:red' : 'color:black'
                "
                @click="form.currentpage = parseInt(data)"
              >
                {{ grid.paginaiton.pageNo == data ? "[" + data + "]" : data }}
              </span>
              <input
                type="button"
                class="btn"
                value=">>"
                style="height: 28px"
                v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                @click="form.currentpage = grid.paginaiton.pageNo + 1"
              />
              ［每頁<input
                type="text"
                v-model.number.lazy="form.pagesize"
                size="2"
                maxlength="4"
              />

              <input type="button" class="btn" value="筆" />，第<input
                type="text"
                v-model.number.lazy="form.currentpage"
                size="2"
                maxlength="4"
              />
              <input type="button" class="btn" value="頁" />，共
              {{ grid.paginaiton.totalPage }} 頁
              {{ grid.paginaiton.totalCount }} 筆］
            </td>
          </tr>
        </tbody>
      </table>
      <div class="active">
        <div class="table_scroll2">
          <table width="1060" class="itable">
            <thead>
              <tr>
                <th colspan="2">操作</th>
                <th style="width: 10%">類別代碼</th>
                <th style="width: 80px">類別名稱</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in grid.gridDatas" :key="index">
                <td width="1%" align="center">
                  <input
                    type="button"
                    class="btn"
                    @click="btnEdit(data)"
                    value="編"
                  />
                </td>
                <td width="1%" align="center">
                  <input
                    type="button"
                    class="btn"
                    @click="btnDelete(data)"
                    value="刪"
                  />
                </td>
                <td>{{ data.clasS_SEQ }}</td>
                <td>{{ data.clasS_NAME }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- 查詢結果結束-->
    <PdisFooter />

    <DetailModal
      v-model="DetailModal.show"
      :title="DetailModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>常見問題類別</td>
                <td colspan="3">
                  <input
                    type="text"
                    v-model="DetailModal.form.clasS_SEQ"
                    :disabled="DetailModal.modifyType == 'U'"
                  />
                </td>
              </tr>
              <tr>
                <td>常見問題類別名稱</td>
                <td colspan="3">
                  <p>
                    <input
                      type="text"
                      v-model="DetailModal.form.clasS_NAME"
                      size="80"
                      maxlength="80"
                    />
                    <br />
                  </p>
                </td>
              </tr>
              <tr>
                <td>排序</td>
                <td colspan="3">
                  <p>
                    <input
                      type="text"
                      v-model.number="DetailModal.form.ord"
                      size="3"
                      maxlength="3"
                    />
                    <br />
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <input
                    type="submit"
                    class="btn"
                    value="存檔"
                    @click="btnDetailSave()"
                  />
                  <input
                    type="submit"
                    class="btn"
                    value="新增問題"
                    @click="btnDetailAdd()"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>

      <div class="information">
        <div class="active">
          <div class="table_scroll2">
            <table width="860" class="itable">
              <thead>
                <tr>
                  <th style="text-align: center" colspan="2">操作</th>
                  <th style="width: 10%; text-align: center">排序</th>
                  <th style="width: 80px; text-align: center">問題</th>
                  <th style="width: 80px; text-align: center">答案</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in DetailModal.form.gridQas"
                  :key="index"
                >
                  <td width="1%" align="center">
                    <input
                      type="button"
                      class="btn"
                      @click="btnDetailEdit(data)"
                      value="編"
                    />
                  </td>
                  <td width="1%" align="center">
                    <input
                      type="button"
                      class="btn"
                      @click="btnDetailDelete(data)"
                      value="刪"
                    />
                  </td>
                  <td>{{ data.ordeR_NUM }}</td>
                  <td style="text-align: left">{{ data.qA_Q }}</td>
                  <td style="text-align: left" v-html="data.qA_A"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </DetailModal>

    <DetailQaModal
      v-model="DetailQaModal.show"
      :title="DetailQaModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>常見問題類別</td>
                <td colspan="3">
                  <select
                    :disabled="DetailQaModal.modifyType == 'U'"
                    v-model="DetailQaModal.form.clasS_SEQ"
                    style="min-width: 480px"
                  >
                    <option
                      v-for="(item, index) in dropDownList.classSeq"
                      :value="item.classSeq"
                      :key="index"
                    >
                      {{ item.className }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>排序</td>
                <td colspan="3">
                  <p>
                    <input
                      type="text"
                      v-model="DetailQaModal.form.ordeR_NUM"
                      size="3"
                      maxlength="3"
                    />
                    <br />
                  </p>
                </td>
              </tr>
              <tr>
                <td>問題</td>
                <td style="text-align: left" colspan="3">
                  <p>
                    <input
                      type="text"
                      v-model="DetailQaModal.form.qA_Q"
                      size="80"
                      maxlength="80"
                    />
                    <br />
                  </p>
                </td>
              </tr>
              <tr>
                <td>答案</td>
                <td style="text-align: left" colspan="3">
                  <p>
                    <ckeditor :config="CkeditorConfig" :editor="editor" v-model="DetailQaModal.form.qA_A" style="width: 800px; height: 250px"></ckeditor>
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"
                    ><span>
                      <input
                        type="submit"
                        class="btn"
                        value="存檔"
                        @click="btnDetailQaSave()"
                      />
                      <input
                        type="submit"
                        class="btn"
                        value="重填"
                        @click="btnDetailQaClear()"
                      /> </span
                  ></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </DetailQaModal>

    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { getMenuIndex,getMenu, logOut } from "@/config/util.js";
import {
  S406_SearchGrid,
  S406_SearchQaclassMaxOrd,
  S406_Delete,
  S406_Detail,
  S406_DetailAddSave,
  S406_DetailEditSave,
  S406_DeleteQa,
  S406_DetailQa,
  S406_DetailQaAddSave,
  S406_DetailQaEditSave,
  S406_SearchQaclass,
} from "@/service/api.js";
export default {
  name: "S406",
  data: function () {
    return {
      editor: ClassicEditor,
      // Classic 樣式
      CkeditorConfig: {
        // 客製化設定
        toolbar: {
          items: [
            'bold', 'italic' , '|' , 'fontSize', 'undo', 'redo', 'numberedList', 'bulletedList'
          ]
          // 設定工具列，可使用'|'隔開功能
        },
        fontSize: {
            options: [
                9,
                11,
                13,
                'default',
                17,
                19,
                21
            ]
        },
        placeholder: '',
        // 當編輯器內容為空時顯示此字串
        initialData: '',
        // 初始化載入文字
        language: 'zh'
        // 設定語言
      },
      pageData: {
        MenuIndex: 6,
        MenuName: "",
        PrgName: "S406",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      form: {
        pkno: "",
        clasS_SEQ: 0,
        clasS_NAME: "",
        ord: "",
        userid: "", //self.loginInfo.id,
        pagesize: 10,
        currentpage: 1,
      },
      dropDownList: {
        classSeq: [],
      },
      grid: {},
      DetailModal: {
        show: false,
        title: "S406 常見問題維護",
        form: {
          pkno: "",
          clasS_SEQ: 0,
          clasS_NAME: "",
          ord: "",
          gridQas: [
            {
              pkno: 0,
              clasS_SEQ: 0,
              qA_Q: "",
              qA_A: "",
              ordeR_NUM: "",
            },
          ],
          userid: "", //self.loginInfo.id,
        },
        modifyType: "", //"I,U"
        dropDownList: {
          classSeq: [],
        },
        PreData: {},
      },
      DetailQaModal: {
        show: false,
        title: "S406 常見問題維護",
        form: {
          pkno: 0,
          clasS_SEQ: 0,
          qA_Q: "",
          qA_A: "",
          ordeR_NUM: "",
          userid: "", //self.loginInfo.id,
        },
        modifyType: "", //"I,U"
        dropDownList: {
          classSeq: [],
        },
        PreData: {},
      },
      Alert: {
        show: false,
        title: "",
        txt: "",
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    Alert: VueModal,
    DetailModal: VueModal,
    DetailQaModal: VueModal,
  },
  methods: {
    GetclassSeqDropDownList: function () {
      const self = this;
      S406_SearchQaclass({ ServiceUnit: self.pageData.ServiceUnit }).then(
        (rData) => {
          self.dropDownList.classSeq = rData.returnObject;
          self.DetailQaModal.dropDownList.classSeq = rData.returnObject;
        }
      );
    },
    //第一頁查詢
    doQuery: function () {
      const self = this;
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        ServiceUnit: self.pageData.ServiceUnit,
        clasS_SEQ: self.form.class_Seq,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S406_SearchGrid(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    //分頁防呆檢查
    checkPage: function (currentpage, pagesize) {
      const self = this;
      let pageErrorMsg = [];
      if (currentpage) {
        if (isNaN(parseInt(currentpage))) {
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if (pagesize) {
        if (isNaN(parseInt(pagesize))) {
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if (pageErrorMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
    //第一頁新增
    btnAdd: function () {
      const self = this;
      self.DetailModal.PreData = {};
      self.btnDetailClear();
      self.DetailModalInit();
      self.DetailModal.modifyType = "I";
      S406_SearchQaclassMaxOrd({ ServiceUnit: self.pageData.ServiceUnit }).then(
        (rData) => {
          self.DetailModal.form.ord = rData.returnObject + 1;
          self.DetailModal.title = "S406 常見問題維護-新增";
          self.DetailModal.show = true;
        }
      );
    },
    //第一頁編
    btnEdit: function (data) {
      const self = this;
      self.DetailModal.PreData = data;
      self.getDetailData();
      self.DetailModalInit();
      self.DetailModal.modifyType = "U";
      self.DetailModal.title = "S406 常見問題維護-編輯";
      self.DetailModal.show = true;
    },
    //第一頁刪
    btnDelete: function (data) {
      const self = this;
      S406_Delete({
        ServiceUnit: self.pageData.ServiceUnit,
        pkno: data.pkno,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "刪",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      }).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["刪除成功"];
          self.Alert.BtnConfirm = () => {
            self.GetclassSeqDropDownList();
            self.form.class_Seq = 0;
            self.doQuery();
            self.Alert.show = false;
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["刪除失敗"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第二頁明細init
    DetailModalInit: function () {
      const self = this;
      self.GetclassSeqDropDownList();
    },
    //第二頁新增
    btnDetailAdd: function () {
      const self = this;
      self.DetailQaModal.PreData = {};
      self.btnDetailQaClear();
      self.DetailQaModalInit();
      self.DetailQaModal.modifyType = "I";
      self.DetailQaModal.title = "S406 常見問題維護-新增";
      self.DetailQaModal.show = true;
      if (self.DetailModal.modifyType == "U") {
        self.DetailQaModal.form.clasS_SEQ = self.DetailModal.form.clasS_SEQ;
      }
    },
    //第二頁編
    btnDetailEdit: function (data) {
      const self = this;
      self.DetailQaModal.PreData = data;
      self.getDetailQaData();
      self.DetailQaModalInit();
      self.DetailQaModal.modifyType = "U";
      self.DetailQaModal.title = "S406 常見問題維護-編輯";
      self.DetailQaModal.show = true;
    },
    //第二頁刪
    btnDetailDelete: function (data) {
      const self = this;
      S406_DeleteQa({
        ServiceUnit: self.pageData.ServiceUnit,
        pkno: data.pkno,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁刪",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      }).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["刪除成功"];
          self.Alert.BtnConfirm = () => {
            self.doQuery();
            self.getDetailData();
            self.Alert.show = false;
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["刪除失敗"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第三頁明細init
    DetailQaModalInit: function () {
      const self = this;
      self.GetclassSeqDropDownList();
    },
    //第二頁明細內容 API
    getDetailData: function () {
      const self = this;
      S406_Detail({
        ServiceUnit: self.pageData.ServiceUnit,
        pkno: self.DetailModal.PreData.pkno,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁明細內容",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      }).then((rData) => {
        if (rData.result) {
          self.DetailModal.grid = rData.returnObject;
          self.DetailModal.form = {
            clasS_SEQ: self.DetailModal.grid.clasS_SEQ,
            clasS_NAME: self.DetailModal.grid.clasS_NAME,
            ord: self.DetailModal.grid.ord,
            userid: "", //self.loginInfo.id,
            gridQas: self.DetailModal.grid.gridQas,
          };
        }
      });
    },
    //第三頁明細內容 API
    getDetailQaData: function () {
      const self = this;
      S406_DetailQa({
        ServiceUnit: self.pageData.ServiceUnit,
        pkno: self.DetailQaModal.PreData.pkno,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第三頁明細內容",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      }).then((rData) => {
        if (rData.result) {
          self.DetailQaModal.grid = rData.returnObject[0];
          self.DetailQaModal.form = {
            clasS_SEQ: self.DetailQaModal.grid.clasS_SEQ,
            qA_Q: self.DetailQaModal.grid.qA_Q,
            qA_A: self.DetailQaModal.grid.qA_A,
            ordeR_NUM: self.DetailQaModal.grid.ordeR_NUM,
            userid: "", //self.loginInfo.id,
          };
        }
      });
    },
    //第二頁明細新增 API
    S406_DetailAddSave: function () {
      const self = this;
      let postData = {
        ServiceUnit: self.pageData.ServiceUnit,
        pkno: 0,
        clasS_SEQ: parseInt(self.DetailModal.form.clasS_SEQ),
        clasS_NAME: self.DetailModal.form.clasS_NAME,
        ord: self.DetailModal.form.ord,
        userid: "", //self.loginInfo.id,
        gridQas: self.DetailModal.form.gridQas,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁明細新增",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      Object.keys(postData).map(
        (k) =>
          (postData[k] =
            typeof postData[k] == "string" ? postData[k].trim() : postData[k])
      );
      console.log(JSON.stringify(postData));
      S406_DetailAddSave(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["新增成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.DetailModal.show = false;
            self.GetclassSeqDropDownList();
            self.doQuery();
          };
        } else {
          self.Alert.title = "錯誤";
          self.Alert.show = true;
          if (rData.messages.length) {
            self.Alert.txt = rData.messages;
          } else {
            self.Alert.txt = ["新增失敗"];
          }
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第二頁明細修改 API
    S406_DetailEditSave: function () {
      const self = this;
      let postData = {
        ServiceUnit: self.pageData.ServiceUnit,
        clasS_SEQ: parseInt(self.DetailModal.form.clasS_SEQ),
        clasS_NAME: self.DetailModal.form.clasS_NAME,
        ord: self.DetailModal.form.ord,
        pkno: self.DetailModal.PreData.pkno,
        gridQas: self.DetailModal.form.gridQas,
        userid: "", //self.loginInfo.id
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁明細修改",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      Object.keys(postData).map(
        (k) =>
          (postData[k] =
            typeof postData[k] == "string" ? postData[k].trim() : postData[k])
      );
      console.log(JSON.stringify(postData));
      S406_DetailEditSave(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["修改成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.DetailModal.show = false;
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["修改失敗"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    checkDetailInutData: function () {
      const self = this;
      let errorMsg = [];
      if (!self.DetailModal.form.clasS_SEQ) {
        errorMsg.push("請填寫常見問題類別");
      } else if (isNaN(parseInt(self.DetailModal.form.clasS_SEQ))) {
        errorMsg.push("常見問題類別請輸入整數");
      }
      if (self.DetailModal.form.clasS_NAME.trim() == "") {
        errorMsg.push("請填寫常見問題類別名稱");
      }
      if (self.DetailModal.form.ord == "") {
        errorMsg.push("請填寫排序");
      } else if (isNaN(parseInt(self.DetailModal.form.ord))) {
        errorMsg.push("排序需為整數");
      } else if (self.DetailModal.form.ord == "0") {
        errorMsg.push("請填寫排序(不可為0)");
      }
      return errorMsg;
    },
    //第二頁按紐明細存檔
    btnDetailSave: function () {
      const self = this;
      let msg = self.checkDetailInutData();
      if (msg.length) {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = msg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
      } else {
        if (self.DetailModal.modifyType == "I") {
          self.S406_DetailAddSave();
        } else if (self.DetailModal.modifyType == "U") {
          self.S406_DetailEditSave();
        }
      }
    },
    //第二頁明細重填
    btnDetailClear: function () {
      const self = this;
      self.DetailModal.form = {
        clasS_NAME: "",
      };
    },
    checkDetailQaInputData: function () {
      const self = this;
      let errorMsg = [];
      if (!self.DetailQaModal.form.clasS_SEQ) {
        errorMsg.push("請填寫常見問題類別");
      }
      if (!self.DetailQaModal.form.ordeR_NUM) {
        errorMsg.push("請填寫排序");
      } else if (isNaN(parseInt(self.DetailQaModal.form.ordeR_NUM))) {
        errorMsg.push("排序需為整數");
      }
      if (!self.DetailQaModal.form.qA_Q) {
        errorMsg.push("請填寫問題");
      }
      if (!self.DetailQaModal.form.qA_A) {
        errorMsg.push("請填寫答案");
      }
      return errorMsg;
    },
    //第三頁按紐明細存檔
    btnDetailQaSave: function () {
      const self = this;
      let ErrMsg = self.checkDetailQaInputData();
      if (ErrMsg.length) {
        self.Alert.txt = ErrMsg;
        self.Alert.show = true;
        self.Alert.title = "提醒";
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
      } else {
        if (self.DetailQaModal.modifyType == "I") {
          self.S406_DetailQaAddSave();
        } else if (self.DetailQaModal.modifyType == "U") {
          self.S406_DetailQaEditSave();
        }
      }
    },
    //第三頁明細重填
    btnDetailQaClear: function () {
      const self = this;
      self.DetailQaModal.form = {
        qA_Q: "",
        qA_A: "",
        ordeR_NUM: "",
      };
    },
    //第三頁明細新增 API
    S406_DetailQaAddSave: function () {
      const self = this;
      let postData = {
        ServiceUnit: self.pageData.ServiceUnit,
        pkno: 0,
        clasS_SEQ: self.DetailQaModal.form.clasS_SEQ,
        qA_Q: self.DetailQaModal.form.qA_Q,
        qA_A: self.DetailQaModal.form.qA_A,
        ordeR_NUM: self.DetailQaModal.form.ordeR_NUM,
        userid: "", //self.loginInfo.id,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第三頁明細新增",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      console.log(JSON.stringify(postData));
      S406_DetailQaAddSave(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["新增成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.DetailQaModal.show = false;
            self.doQuery();
            self.getDetailData();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["新增失敗"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
        //console.log(rData);
      });
    },
    //第三頁明細修改 API
    S406_DetailQaEditSave: function () {
      const self = this;
      let postData = {
        ServiceUnit: self.pageData.ServiceUnit,
        clasS_SEQ: self.DetailQaModal.form.clasS_SEQ,
        qA_Q: self.DetailQaModal.form.qA_Q,
        qA_A: self.DetailQaModal.form.qA_A,
        ordeR_NUM: self.DetailQaModal.form.ordeR_NUM.toString(),
        pkno: self.DetailQaModal.PreData.pkno,
        userid: "", //self.loginInfo.id
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第三頁明細修改",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      console.log(JSON.stringify(postData));
      S406_DetailQaEditSave(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["修改成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.DetailQaModal.show = false;
            self.doQuery();
            self.getDetailData();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["修改失敗"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if(Menu){
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.dropDownList.classSeq = self.GetclassSeqDropDownList();
  },
  watch: {
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.doQuery();
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.doQuery();
      }
    },
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
